import { Disposable } from "common/disposable";
import { Disposer } from "common/disposer";
import { PixiContext } from "common/pixi";
import { createApplication, createCenterContainer } from "common/pixi/app";
import { ReesizeEventHandler } from "common/resize";
import { Black } from "common/sprites/black";
import * as HeartSignalInteraction from "./heartSignalInteraction";
import * as LoadingAnimation from "./loadingAnimation";
import { Background, Button, Heart, loadSheets, Shade, Title, } from "./resources";
import { letterbox } from "./screen";
export class Scene {
    async start({ sound, parentSelector, }) {
        const resizer = new ReesizeEventHandler();
        letterbox(resizer);
        sound.playLoop("ambulanceBackground");
        sound.play("opening");
        sound.awaitPlay("openingTransition").then(() => {
            sound.play("grandpaEffect");
        });
        const app = createApplication(parentSelector);
        const pixiContext = new PixiContext(app);
        const sheets = await loadSheets();
        const disposable = new Disposable();
        disposable.add(new Disposer(() => sound.dispose()));
        const elements = loadAllElements({ pixiContext, sheets, app, disposable });
        const sceneContext = {
            elements,
            disposable,
            app,
            sound,
            pixiContext: new PixiContext(app),
        };
        addElementsToScene(sceneContext);
        const ticker = sceneContext.pixiContext.ticker;
        // ticker.speed = 1000;
        await LoadingAnimation.run(sceneContext);
        ticker.speed = 1;
        await HeartSignalInteraction.run(sceneContext);
        pixiContext.dispose();
        sceneContext.disposable.dispose();
        resizer.drop();
        return sceneContext;
    }
}
function loadAllElements({ app, sheets, disposable, pixiContext, }) {
    return {
        background: new Background(pixiContext, sheets),
        black: new Black(app),
        button: new Button({ pixiContext, sheets: sheets, disposable: disposable }),
        shade: new Shade(sheets),
        title: new Title(pixiContext, sheets),
        heart: new Heart(pixiContext, sheets),
    };
}
function addElementsToScene({ elements: { background, black, button, shade, title, heart }, app, }) {
    const centerContainer = createCenterContainer();
    app.stage.addChild(centerContainer);
    const pixiObjects = [
        background.sprite,
        button.sprite,
        shade.sprite,
        heart.sprite,
        black.sprite,
        title.sprite,
    ];
    for (const pixiObject of pixiObjects) {
        pixiObject.visible = false;
        centerContainer.addChild(pixiObject);
    }
}
//# sourceMappingURL=main.js.map